import { UseFormRegister, Controller, Control } from 'react-hook-form';
import { InquiryForm } from '../../../models/Inquiry/Inquiry';

interface FormRowProps {
  name: string;
  key_value: keyof InquiryForm;
  register: UseFormRegister<InquiryForm>;
  control?: Control<InquiryForm>;
  type?: 'text' | 'checkbox' | 'select';
  options?: { label: string; value: string | number }[];
}

const renderRowType = (
  type: 'text' | 'checkbox' | 'select',
  register: UseFormRegister<InquiryForm>,
  key_value: keyof InquiryForm,
  control?: Control<InquiryForm>,
  options?: { label: string; value: string | number }[],
) => {
  switch (type) {
    case 'text':
      return (
        <input
          type="text"
          id={key_value}
          name={key_value}
          className="form-control"
          {...register(key_value)}
        />
      );
    case 'checkbox':
      return (
        <div className="form-check form-switch">
          <input
            type="checkbox"
            id={key_value}
            name={key_value}
            className="form-check-input"
            {...register(key_value)}
          />

          <label
            title=""
            htmlFor={key_value}
            className="form-check-label"
          >
            有効にする
          </label>
        </div>
      );
    case 'select':
      if (!control) {
        return (
          <select
            className="form-select"
            {...register(key_value, { valueAsNumber: true })}
          >
            {options?.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      }

      return (
        <Controller
          name={key_value}
          control={control}
          render={({ field }) => {
            // Ensure value is a number for select fields
            const selectValue = typeof field.value === 'number' ? field.value : 0;

            return (
              <select
                className="form-select"
                {...field}
                value={selectValue}
                onChange={(e) => field.onChange(Number(e.target.value))}
              >
                {options?.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            );
          }}
        />
      );
    default:
      return null;
  }
};

const FormRow = ({
  name,
  register,
  control,
  key_value,
  type = 'checkbox',
  options,
}: FormRowProps) => (
  <div className="mb-3 row">
    <label className="col-sm-2 form-label">
      <span className="fw-bold">
        {name}
      </span>
    </label>
    <div className="col-sm-10">
      {renderRowType(type, register, key_value, control, options)}
      <div className="invalid-feedback" />
    </div>
  </div>
);

export default FormRow;
